<template>
  <div class="trust">
        <div class="loader">Loading...</div>
  </div>
</template>

<script src="./trust.js"></script>
